import React, { Suspense, useState } from 'react';

import { useCompany } from 'src/app/Company.store';
import { LoadingPage } from 'src/components/shared';
import { EmailCodeLogin } from './EmailCodeLogin';

// Lazy-loaded so the registration wizard subtree stays out of the eager
// first-paint bundle; it only mounts after an explicit "create account" click.
const RegistrationSurface = React.lazy(() =>
  import('src/components/registration/RegistrationSurface').then((m) => ({
    default: m.RegistrationSurface,
  }))
);

// Temporarily hide the "Create an account" button on the login screen without
// removing the registration capability. Flip back to `true` to restore it (the
// per-tenant `crm_enable_registration` flag still gates it beyond this).
const SHOW_REGISTER = false;

export const EmailLoginSurface: React.FC = () => {
  const { data: company } = useCompany();
  const [mode, setMode] = useState<'login' | 'register'>('login');

  if (mode === 'register') {
    return (
      <Suspense fallback={<LoadingPage />}>
        <RegistrationSurface onDone={() => setMode('login')} />
      </Suspense>
    );
  }
  return (
    <EmailCodeLogin
      onRegister={
        SHOW_REGISTER && company?.crm_enable_registration
          ? () => setMode('register')
          : undefined
      }
    />
  );
};
